import { setLocale, object, string, ref, number, array, boolean, date } from "yup";

setLocale({
  mixed: {
    required: 'Campo requerido',
  },
  string: {
    email: 'Correo electrónico no valido',
    min: 'Mínimo ${min} caracteres',
    max: 'Máximo ${max} caracteres',
    date: 'Fecha inválida',
  },
  date: {
    max: 'No debe sobrepasar la fecha actual.',
  },
});

export const loginEmailSchema = object().shape({
  email: string().email().required(),
  password: string()/* .min(8).max(32) */.required(),
});

export const registerEmailSchema = object().shape({
  name: string().required(),
  last_name: string().required(),
  second_last_name: string(),
  phone: string(),
  email: string().email().required(),
  password: string()/* .min(8).max(32) */.required(),
  confirmPassword: string().oneOf([ref('password'), null], 'Las contraseñas deben coincidir').required(),
  code: string(),
});

export const passwordRecoveryEmailSchema = object().shape({
  email: string().email().required(),
});

export const passwordResetSchema = object().shape({
  password: string().min(8).required(),
  confirmPassword: string().oneOf([ref('password'), null], 'Las contraseñas deben coincidir').required(),
});

export const passwordChangeEmailSchema = object().shape({
  password: string().min(8).required(),
  confirmPassword: string().oneOf([ref('password'), null], 'Las contraseñas deben coincidir').required(),
});

export const emailConfirmationCodeSchema = object().shape({
  d1: number().required().positive('Debe ser positivo'),
  d2: number().required().positive('Debe ser positivo'),
  d3: number().required().positive('Debe ser positivo'),
  d4: number().required().positive('Debe ser positivo'),
  d5: number().required().positive('Debe ser positivo'),
  d6: number().required().positive('Debe ser positivo'),
});

// CONTACTS
export const createContactSchema = object().shape({
  name: string().required(),
  phone: string().matches(
    /^([56]\d{7}|\+53[56]\d{7}|\+53\s[56]\d{7}|)$/,
    'Teléfono inválido (ej. válido: 5xxxxxxx, 6xxxxxxx, +535xxxxxxx, +536xxxxxxx o +53 5xxxxxxx)'
  ).notRequired(),
  email: string().email().matches(
    /(@nauta\.cu$|^$)/,
    'Correo inválido, debe terminar en @nauta.cu'
  ).notRequired(),
})/* .test('phone_or_email', 'Debes proporcionar al menos un teléfono o correo electrónico', function (values) {
  return (Boolean(values.phone) || Boolean(values.email));
}) */; // se paso a validar desde el componente

/* RECHARGES */
export const rechargeMovilSchema = object().shape({
  contacts: array()
    .of(
      object().shape({
        phone: string()
          .matches(/^[0-9]*$/, 'Teléfono inválido, debe contener solo números')
          .length(8, 'Teléfono inválido, debe tener 8 dígitos')
          .required()
      })
    )
    .min(1, 'Debe tener al menos un teléfono en la lista')
});

export const rechargeNautaSchema = object().shape({
  contacts: array()
    .of(
      object().shape({
        email: string()
          .matches(/^[\w-.]+@nauta\.cu$/, 'Cuenta Nauta inválida')
          .required()
      })
    )
    .min(1, 'Debe tener al menos una cuenta en la lista')
});

/* Contact Us */
export const contactUsSchema = object().shape({
  name: string().required(),
  email: string().email('Correo electrónico inválido').required(),
  phone: string().matches(/^[0-9]*$/, 'Teléfono inválido').required(),
  message: string().max(500, 'El mensaje no puede superar los 500 caracteres').required(),
  terms: boolean().oneOf([true], 'Debes aceptar los términos y condiciones'),
});

/* Payment */
export const paymentSchema = object().shape({
  politics: boolean().oneOf([true], 'Debes aceptar los términos y condiciones'),
});

/* PRODUCTS */
/* products */
export const createProductSchema = object().shape({
  name: string().required(),
  description: string().required().max(500),
  price_usd: number().typeError('Falta número').required().positive('Debe ser positivo'),
  scheduled_price_usd: number().typeError('Falta número').required().positive('Debe ser positivo'),
  offer_price_usd: number().typeError('Falta número').required().positive('Debe ser positivo'),
  price_eur: number().typeError('Falta número').required().positive('Debe ser positivo'),
  scheduled_price_eur: number().typeError('Falta número').required().positive('Debe ser positivo'),
  offer_price_eur: number().typeError('Falta número').required().positive('Debe ser positivo'),
  provider_price_usd: number().typeError('Falta número').required().positive('Debe ser positivo'),
  provider_price_eur: number().typeError('Falta número').required().positive('Debe ser positivo'),
  dtone_product_id: number().typeError('Falta número').required().positive('Debe ser positivo'),
  assign_points: number().typeError('Falta número').required().positive('Debe ser positivo'),
  offer_assign_points: number().typeError('Falta número').required().positive('Debe ser positivo'),
  cost_points: number().typeError('Falta número').required().positive('Debe ser positivo'),
  type: string(),
});

/* Promotions */
export const createPromotionshema = object().shape({
  name: string().required(),
  description: string().max(500),
  date_init: string().required(),
  date_end: string().required(),
  promo_id: number().nullable(),
});

const passwordSchema = string()
  .min(8, 'La contraseña debe tener al menos 8 caracteres')
  .matches(/[a-z]/, 'La contraseña debe contener al menos una letra minúscula')
  .matches(/[A-Z]/, 'La contraseña debe contener al menos una letra mayúscula')
  .matches(/\d/, 'La contraseña debe contener al menos un número')
  .matches(/\W/, 'La contraseña debe contener al menos un carácter especial')
  .required('La contraseña es requerida');

/* new user */
export const newUserSchema = object().shape({
  name: string().required(),
  email: string().matches(/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/, 'Correo electrónico inválido').required(),
  password: passwordSchema,
  confirmPassword: string().oneOf([ref('password'), null], 'Las contraseñas deben coincidir').required(),
  birthday: date()
    .typeError('Fecha inválida')
    .nullable('No puede ser nulo')
    .max(new Date(), 'No debe sobrepasar la fecha actual.')
});

/* edit user */
export const editUserSchema = object().shape({
  name: string().required(),
  email: string().matches(/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/, 'Correo electrónico inválido').required(),
  phone: string().matches(/(^\+?\d+$|^$)/, 'Inserte un teléfono válido').notRequired(),
  birthday: date()
    .typeError('Fecha inválida')
    .nullable('No puede ser nulo')
    .max(new Date(), 'No debe sobrepasar la fecha actual.'),
});

/* GROUP */
// new group
export const newGroupSchema = object().shape({
  name: string().required(),
  discount_usd: number().typeError('Falta número').required().positive('Debe ser positivo'),
  discount_eur: number().typeError('Falta número').required().positive('Debe ser positivo'),
  ids: array().min(1, 'Debe tener al menos un usuario seleccionado'),
  description: string().max(100),
});

/* INVITES */
export const newInviteSchema = object().shape({
  name: string().required(),
  email: string().email('Correo electrónico inválido').required(),
  amount: number().typeError('Falta número').required().positive('Debe ser positivo'),
});

/* CONFIGURATION */
export const updateUserProfile = object().shape({
  name: string(),
  email: string().matches(/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/, 'Correo electrónico inválido'),
  phone: string().matches(/(^\+?\d+$|^$)/, 'Inserte un teléfono válido').notRequired(),
});

